module.exports = __webpack_public_path__ + "static/media/right-shield-big.1acbcb17.svg";